import React from 'react';

// Renders **text** as emphasized spans.
export default function RichText({ text, strongClassName = 'font-semibold text-primary' }) {
  return text.split(/\*\*(.+?)\*\*/).map((part, i) =>
    i % 2 ? <span key={i} className={strongClassName}>{part}</span> : part
  );
}

// Replaces {key} placeholders in a template with the given values (strings or elements).
export function fillTemplate(template, values) {
  return template.split(/\{(\w+)\}/).map((part, i) =>
    <React.Fragment key={i}>{i % 2 ? values[part] : part}</React.Fragment>
  );
}
